import { IPIRANGA_PROMOTION_AVAILABLE } from '../actionTypes/ipirangaPromotion'

const INITIAL_STATE = {
  available: false,
  // distingue "ainda não perguntei ao back" de "back respondeu false" —
  // usado pelo boot gate do defaultLayout
  resolved: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IPIRANGA_PROMOTION_AVAILABLE:
      return { ...state, available: action.payload === true, resolved: true }
    default:
      return state
  }
}
